import { HRDMark } from "../components/HRDMark";
import { Icon } from "../components/Icons";
import type { MeetingPublicView } from "../api/types";

export function Ended({ meeting }: { meeting: MeetingPublicView }) {
  const isRecruiter = meeting.role === "recruiter";
  return (
    <div className="ended">
      <div className="vr-topbar">
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <HRDMark size={22} />
          <span className="vr-topbar-mono">HRDeva · Видеокабинет</span>
        </div>
        <div className="vr-topbar-divider" />
        <div className="vr-topbar-meta">
          <div className="vr-topbar-title">
            {meeting.vacancy_title
              ? `Интервью · ${meeting.vacancy_title}`
              : "Видео-интервью"}
          </div>
          <div className="vr-topbar-sub">встреча завершена</div>
        </div>
      </div>

      <div className="ended-stage">
        <div className="ended-card">
          <div className="ended-check">
            <Icon name="check" size={28} stroke={2.5} />
          </div>
          <div
            style={{
              fontSize: 22,
              fontWeight: 600,
              letterSpacing: "-0.01em",
              marginBottom: 8,
            }}
          >
            {isRecruiter ? "Встреча завершена" : "Спасибо за интервью!"}
          </div>
          <div
            style={{
              fontSize: 13.5,
              color: "var(--text-2)",
              lineHeight: 1.55,
              marginBottom: 22,
            }}
          >
            {isRecruiter
              ? "Запись и ваши заметки прикреплены к карточке кандидата."
              : "Запись передана рекрутёру. Мы вернёмся с решением — следите за сообщениями в чате HRDeva."}
          </div>

          {isRecruiter && (
            <button
              style={{
                height: 40,
                padding: "0 18px",
                borderRadius: 8,
                background: "var(--accent)",
                color: "var(--accent-fg)",
                fontFamily: "var(--font-sans)",
                fontSize: 13,
                fontWeight: 600,
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                cursor: "pointer",
              }}
              onClick={() => window.close()}
            >
              <Icon name="person" size={14} /> Открыть карточку кандидата
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
